import { render } from "./Inputs.vue?vue&type=template&id=2f374f52"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__